export enum Campaigns {
  freemium = "FREEMIUM_CAMPAIGN",
}
